const FORMULA_CHARS = new Set(['=', '+', '@', ',', '-']);

export const sanitizeFormula = (str) => (str?.length && FORMULA_CHARS.has(str[0]) ? `'${str}` : str);

export const sanitizeCsvData = (csvData) =>
  csvData.map((rowData) => rowData.map((cellData) => sanitizeFormula(cellData)));
